/*
 * When the sidebar's Chat row is the current one. Chat's pages each have a row of their own (the
 * Inbox, Threads, Mentions and Saved rows, and a row per channel and direct message listed), and
 * where one holds the page, it is the current row, not Chat. On the icon rail those rows are
 * hidden, so Chat is current on all of them.
 */

/** Chat's pages that a row of their own holds. */
const ownRows = new Set(["inbox", "threads", "mentions", "saved"])

/**
 * Whether the Chat row is current at `pathname`, given whether the sidebar is the icon `rail` and
 * the conversations it `listed`, by id.
 */
export function chatRowCurrent({
  pathname,
  rail,
  listed,
}: {
  pathname: string
  rail: boolean
  listed: ReadonlySet<string>
}) {
  const [first, page, ...rest] = pathname.split("/").filter(Boolean)
  if (first !== "chat") return false
  if (rail || page === undefined || rest.length) return true
  return !ownRows.has(page) && !listed.has(decodeURIComponent(page))
}
